<template>
  <v-container fluid>
    <v-row v-if="!medicalReport" justify="center">
      <v-col cols="6">
        <v-alert color="blue" outlined text type="info">
          Estamos criando a base para o relatório...
        </v-alert>
        </v-col>
      </v-row>

    <v-row v-else dense align="center" justify="end">
      <v-col class="text-h3 gray--text"> Relatório</v-col>
        <v-col cols="auto">
          <v-btn
            outlined
            color="light-blue"
            :disabled="!medicalReport || printLoading || !typing"
            :loading="printLoading"
            @click="saveManager.triggerManualSave()"
          >
           Salvar
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <v-btn
            outlined
            color="light-blue"
            @click="downloadmedicalReport"
            :disabled="!medicalReport || printLoading || typing"
            :loading="printLoading"
          >
            Imprimir
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <EsignButton
            :esign="medicalReport.lastEsign"
            v-if="medicalReport"
          />
        </v-col>
      <v-col cols="auto">
        <v-btn
          color="gray lighten-1"
          dark
          :to="`/prontuario/${attendance.id}/relatorios`"
        >
          voltar
        </v-btn>
      </v-col>
    </v-row>

    <authorization  permissionKey="attendance_medical_record" can="read">
      <v-row dense>
        <v-col>
          <v-text-field
            label="Título"
            :disabled="!medicalReport || printLoading"
            v-model="name"
            outlined
            dense
            hide-details
            @change="setTyping(true)"
        />
            <!--   :disabled="signed" -->
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <v-combobox
            label="Modelo de relatório"
            v-model="descriptionModelTemplate"
            :disabled="!medicalReport || printLoading"
            dense
            hide-details
            outlined
            item-text="name"
            background-color="white"
            :items="orderedTemplates"
            @change="choseDescriptionTemplate"
          />
          <!--   :disabled="signed" -->
        </v-col>
      </v-row>
      <v-row justify="end" dense>
        <v-col cols="auto">
          <v-switch
            v-model="showDoctor"
            label="Exibir médico no rodapé"
            :disabled="!medicalReport || printLoading"
            @change="setTyping(true)"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <RichText
            :disabled="!medicalReport || printLoading"
            v-model="description"
            @change="setTyping(true)"
          />
          <!-- :disabled="signed" -->
        </v-col>
      </v-row>
    </authorization>
  </v-container>
</template>

<script>

import { AutoSaveManager } from "@/services/AutoSaveManager/index.js";

export default {
  name: "MedicalReport",
  props: {
    attendance: Object,
  },
  data() {
    return {
      typing: false,
      name: "",
      descriptionModelTemplate: null,
      medicalReportId: null,
      description: "",
      showDoctor: false,
      printLoading: false,
      skipSave: false,
      template: "",
      saveManager: null,
    };

  },

  created() {
    if (this.$route.params.medicalReportId) {
      this.medicalReportId = this.$route.params.medicalReportId;
    }

    this.saveManager = new AutoSaveManager({
      formName: "Relatório", 
      beforeSave: () => this.beforeSave(),
      onSave: () => this.saveMedicalReport(),
      autoSaveTimeout: 1800000, // 30 minutes
      showUnsavedAlertOnLeave: !this.disabled,
    });
  },

  watch: {
    $route() {
      this.triggerManualSave();
    }
  },

  mounted() {
    this.description = this.medicalReport?.description;
    this.name = this.medicalReport?.name;
    this.showDoctor = this.medicalReport?.showDoctor || false;
  },

  apollo: {
    medicalReport: {
      query: require("@/graphql/medical_report/medical_report.gql"),
      fetchPolicy: "no-cache",
      variables() {
        return {
          medicalReportId: this.medicalReportId,
        };
      },
      skip() {
        return this.medicalReportId === "";
      },
      result({ data }) {
        if (!this.typing) {
          this.name = data.medicalReport?.name;
          this.description = data.medicalReport?.description;
          this.showDoctor = data.medicalReport?.showDoctor || false;
        }
      },
    },
    medicalReportTemplates: {
      query: require("@/graphql/medical_report/medical_report_templates.gql"),
    },
  },
  computed: {
    // signed() {
    //   if (this.medicalReport) {
    //     return this.medicalReport.lastEsign.status !== "editable";
    //   }
    //   return false;
    // },
    orderedTemplates() {
      return this.lodash.orderBy(this.medicalReportTemplates,
        [
          (e) =>
            e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
  },
  methods: {
    async refreshList() {
      await this.$apollo.queries.medicalReport.refetch();
    },

    async beforeSave() {
      return true;
    },

    async saveMedicalReport() {
      this.descriptionModelTemplate = ""
      this.typing = true;
      //if (this.signed) return;
      this.apolloMutate({
        mutation: require("@/graphql/medical_report/save_medical_report.gql"),
        variables: {
          attendanceId: this.attendance.id,
          medicalReportId: this.medicalReportId,
          description: this.description,
          name: this.name,
          showDoctor: this.showDoctor,
        },
      }).then(({ data }) => {
        this.typing = false;
        this.medicalReportId = data.saveMedicalReport.id;
      });
    },

    async choseDescriptionTemplate() {
      if (this.descriptionModelTemplate?.description) {
        if (!this.description) {
          this.description = this.descriptionModelTemplate.description;
        } else {
          this.description += "\n";
          this.description += this.descriptionModelTemplate.description;
        }

        await this.saveMedicalReportOnChange();
      }
    },

    async generatePreview() {
      await this.apolloMutate({
        mutation: require("@/graphql/esign/generate_preview.gql"),
        variables: {
          esignId: this.medicalReport.lastEsign.id,
        },
      });
    },

    async downloadmedicalReport() {
      this.printLoading = true;
      await this.generatePreview();
      await this.refreshList();
      //await this.$store.dispatch("authentication/refreshToken");

      //if (this.glassesPrescription.lastEsign.status === "signed") {
      const file_url = this.medicalReport.lastEsign.fileUrl;

      await window.open(`${process.env.VUE_APP_BASE_URL}${file_url}`, "_blank");
      // } else {
      //   this.$store.dispatch("createNotification", {
      //     message: "É necessário assinar antes de imprimir.",
      //     type: "error",
      //   });
      //}

      this.printLoading = false;
    },

    setTyping(status) {
      if (status != this.typing) {
        this.typing = status;

        return this.saveManager.dispatchAutoSave();
      }
    },
    
    async saveMedicalReportOnChange() {
      this.typing = false;
      this.apolloMutate({
        mutation: require("@/graphql/medical_report/save_medical_report.gql"),
        variables: {
          attendanceId: this.attendance.id,
          medicalReportId: this.medicalReportId,
          description: this.description,
          name: this.name,
          showDoctor: this.showDoctor,
        },
      }).then(({ data }) => {
        this.medicalReportId = data.saveMedicalReport.id;
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>

